interface Translation {
  firstParagraph: string;
  firstParagraphRecording: string;
  firstParagraphTextOnly: string;
  recordingVoice: string;
  recordingVideo: string;
  recordingVoiceAndVideo: string;
  forReference: string;
  interviewTerms: string;
  privacyPolicy: string;
  translatePickLanguage: string;
  letsGo: string;
  consentText: string;
}

// eslint-disable-next-line import/prefer-default-export
export const translations: Record<string, Translation> = {
  af: {
    firstParagraph: 'Ek aanvaar {interviewTerms} en {privacyPolicy}',
    firstParagraphRecording:
      'Ek stem in tot die opname van {recordingType} in hierdie onderhoud en tot die deel van die opname met die navorsingskliënt vir navorsingsdoeleindes.',
    firstParagraphTextOnly:
      'Ek stem in om aan hierdie onderhoud deel te neem en om my antwoorde met die navorsingskliënt vir navorsingsdoeleindes te deel.',
    recordingVoice: 'my stem',
    recordingVideo: 'my video',
    recordingVoiceAndVideo: 'my stem en video',
    forReference: 'Ter verwysing:',
    interviewTerms: 'Onderhoudsvoorwaardes',
    privacyPolicy: 'Privaatheidsbeleid',
    translatePickLanguage: 'Kies jou taal, en dan begin ons.',
    letsGo: 'Kom ons begin',
    consentText: `## Welkom!
Dit is nie 'n tipiese opname nie.

Dit is 'n interaktiewe KI-onderhoud, ontwerp om jou unieke perspektief te hoor.
`,
  },
  am: {
    firstParagraph: 'እኔ {interviewTerms} እና {privacyPolicy} ተቀብያለሁ',
    firstParagraphRecording:
      'በዚህ ቃለ መጠይቅ ውስጥ {recordingType} መቅዳት እና ቅጂውን ከምርምር ደንበኛው ጋር ለምርምር ዓላማ ማጋራት እስማማለሁ።',
    firstParagraphTextOnly:
      'በዚህ ቃለ መጠይቅ ውስጥ ለመሳተፍ እና ምላሾቼን ከምርምር ደንበኛው ጋር ለምርምር ዓላማ ለማጋራት እስማማለሁ።',
    recordingVoice: 'ድምጼን',
    recordingVideo: 'ቪዲዮዬን',
    recordingVoiceAndVideo: 'ድምጼን እና ቪዲዮዬን',
    forReference: 'ለማጣቀሻ:',
    interviewTerms: 'የቃለ መጠይቅ ውሎች',
    privacyPolicy: 'የግላዊነት ፖሊሲ',
    translatePickLanguage: 'ቋንቋዎን ይምረጡ፣ ከዚያ እንጀምራለን።',
    letsGo: 'እንጀምር',
    consentText: `## እንኳን ደህና መጡ!
ይህ ተራ የዳሰሳ ጥናት አይደለም።

ይህ ልዩ አመለካከትዎን ለመስማት የተነደፈ መስተጋብራዊ AI ቃለ መጠይቅ ነው።
`,
  },
  ar: {
    firstParagraph: 'أوافق على {interviewTerms} و {privacyPolicy}',
    firstParagraphRecording:
      'أوافق على تسجيل {recordingType} في هذه المقابلة وعلى مشاركة التسجيل مع عميل البحث لأغراض بحثية.',
    firstParagraphTextOnly:
      'أوافق على المشاركة في هذه المقابلة وعلى مشاركة إجاباتي مع عميل البحث لأغراض بحثية.',
    recordingVoice: 'صوتي',
    recordingVideo: 'الفيديو الخاص بي',
    recordingVoiceAndVideo: 'صوتي والفيديو الخاص بي',
    forReference: 'للاطلاع:',
    interviewTerms: 'شروط المقابلة',
    privacyPolicy: 'سياسة الخصوصية',
    translatePickLanguage: 'اختر لغتك، ثم سنبدأ.',
    letsGo: 'لنبدأ',
    consentText: `## مرحبًا!
هذه ليست استطلاعًا عاديًا.

إنها مقابلة تفاعلية بالذكاء الاصطناعي، صُممت للاستماع إلى وجهة نظرك الفريدة.
`,
  },
  hy: {
    firstParagraph: 'Ես համաձայն եմ {interviewTerms} և {privacyPolicy}',
    firstParagraphRecording:
      'Ես համաձայն եմ այս հարցազրույցում {recordingType} ձայնագրմանը և ձայնագրությունը հետազոտական հաճախորդի հետ կիսելու հետազոտական նպատակներով.',
    firstParagraphTextOnly:
      'Ես համաձայն եմ մասնակցել այս հարցազրույցին և իմ պատասխանները կիսելու հետազոտական հաճախորդի հետ հետազոտական նպատակներով.',
    recordingVoice: 'իմ ձայնի',
    recordingVideo: 'իմ տեսանյութի',
    recordingVoiceAndVideo: 'իմ ձայնի և տեսանյութի',
    forReference: 'Տեղեկատվության համար:',
    interviewTerms: 'Հարցազրույցի պայմաններ',
    privacyPolicy: 'Գաղտնիության քաղաքականություն',
    translatePickLanguage: 'Ընտրեք ձեր լեզուն, և ապա մենք կսկսենք։',
    letsGo: 'Սկսենք',
    consentText: `## Բարի գալուստ!
Սա սովորական հարցում չէ։

Սա ինտերակտիվ արհեստական բանականության հարցազրույց է, որը նախատեսված է լսելու ձեր եզակի տեսանկյունը։
`,
  },
  az: {
    firstParagraph: 'Mən {interviewTerms} və {privacyPolicy} ilə razıyam',
    firstParagraphRecording:
      'Bu müsahibədə {recordingType} qeydə alınmasına və qeydin tədqiqat müştərisi ilə tədqiqat məqsədilə paylaşılmasına razıyam.',
    firstParagraphTextOnly:
      'Bu müsahibədə iştirak etməyə və cavablarımın tədqiqat müştərisi ilə tədqiqat məqsədilə paylaşılmasına razıyam.',
    recordingVoice: 'səsimin',
    recordingVideo: 'videomin',
    recordingVoiceAndVideo: 'səsimin və videomin',
    forReference: 'Arayış üçün:',
    interviewTerms: 'Müsahibə şərtləri',
    privacyPolicy: 'Məxfilik Siyasəti',
    translatePickLanguage: 'Dilinizi seçin, sonra başlayırıq.',
    letsGo: 'Başlayaq',
    consentText: `## Xoş gəlmisiniz!
Bu adi bir sorğu deyil.

Bu sizin unikal baxış bucağınızı eşitmək üçün nəzərdə tutulmuş interaktiv süni intellekt müsahibəsidir.
`,
  },
  be: {
    firstParagraph: 'Я прымаю {interviewTerms} і {privacyPolicy}',
    firstParagraphRecording:
      "Я згаджаюся на запіс {recordingType} у гэтым інтэрв'ю і на абмен запісам з даследчым кліентам у даследчых мэтах.",
    firstParagraphTextOnly:
      "Я згаджаюся прыняць удзел у гэтым інтэрв'ю і падзяліцца маімі адказамі з даследчым кліентам у даследчых мэтах.",
    recordingVoice: 'майго голасу',
    recordingVideo: 'майго відэа',
    recordingVoiceAndVideo: 'майго голасу і відэа',
    forReference: 'Для даведкі:',
    interviewTerms: "Умовы інтэрв'ю",
    privacyPolicy: 'Палітыка прыватнасці',
    translatePickLanguage: 'Абярыце сваю мову, і тады мы пачнем.',
    letsGo: 'Пачнем',
    consentText: `## Сардэчна запрашаем!
Гэта не звычайны апытанне.

Гэта інтэрактыўнае інтэрв'ю з штучным інтэлектам, створанае, каб пачуць ваш унікальны погляд.
`,
  },
  bs: {
    firstParagraph: 'Prihvatam {interviewTerms} i {privacyPolicy}',
    firstParagraphRecording:
      'Pristajem na snimanje {recordingType} u ovom intervjuu i na dijeljenje snimke s istraživačkim klijentom u istraživačke svrhe.',
    firstParagraphTextOnly:
      'Pristajem na učešće u ovom intervjuu i na dijeljenje mojih odgovora s istraživačkim klijentom u istraživačke svrhe.',
    recordingVoice: 'mog glasa',
    recordingVideo: 'mog videa',
    recordingVoiceAndVideo: 'mog glasa i videa',
    forReference: 'Za referencu:',
    interviewTerms: 'Uvjeti intervjua',
    privacyPolicy: 'Politika privatnosti',
    translatePickLanguage: 'Odaberite svoj jezik, a zatim ćemo početi.',
    letsGo: 'Počnimo',
    consentText: `## Dobrodošli!
Ovo nije tipična anketa.

Ovo je interaktivni AI intervju, dizajniran da čuje vašu jedinstvenu perspektivu.
`,
  },
  bg: {
    firstParagraph: 'Признавам {interviewTerms} и {privacyPolicy}',
    firstParagraphRecording:
      'Съгласявам се с записването на {recordingType} в това интервю и със споделянето на записа с изследователския клиент за изследователски цели.',
    firstParagraphTextOnly:
      'Съгласявам се да участвам в това интервю и да споделя отговорите си с изследователския клиент за изследователски цели.',
    recordingVoice: 'гласа ми',
    recordingVideo: 'видеото ми',
    recordingVoiceAndVideo: 'гласа и видеото ми',
    forReference: 'За справка:',
    interviewTerms: 'Условия за интервю',
    privacyPolicy: 'Политика за поверителност',
    translatePickLanguage: 'Изберете своя език и след това ще започнем.',
    letsGo: 'Нека започнеме',
    consentText: `## Добре дошли!
Това не е типична анкета.

Това е интерактивно AI интервю, създадено, за да чуе вашата уникална перспектива.
`,
  },
  bn: {
    firstParagraph: 'আমি {interviewTerms} এবং {privacyPolicy} গ্রহণ করি',
    firstParagraphRecording:
      'আমি এই সাক্ষাৎকারে {recordingType} রেকর্ডিং এবং গবেষণা উদ্দেশ্যে গবেষণা ক্লায়েন্টের সাথে রেকর্ডিং শেয়ার করতে সম্মত।',
    firstParagraphTextOnly:
      'আমি এই সাক্ষাৎকারে অংশগ্রহণ করতে এবং গবেষণা উদ্দেশ্যে গবেষণা ক্লায়েন্টের সাথে আমার উত্তর শেয়ার করতে সম্মত।',
    recordingVoice: 'আমার কণ্ঠস্বরের',
    recordingVideo: 'আমার ভিডিওর',
    recordingVoiceAndVideo: 'আমার কণ্ঠস্বর ও ভিডিওর',
    forReference: 'রেফারেন্সের জন্য:',
    interviewTerms: 'সাক্ষাৎকারের শর্তাবলী',
    privacyPolicy: 'গোপনীয়তা নীতি',
    translatePickLanguage: 'আপনার ভাষা নির্বাচন করুন, তারপর আমরা শুরু করব।',
    letsGo: 'শুরু করা যাক',
    consentText: `## স্বাগতম!
এটি একটি সাধারণ সমীক্ষা নয়।

এটি একটি ইন্টারেক্টিভ AI সাক্ষাৎকার, যা আপনার অনন্য দৃষ্টিভঙ্গি শোনার জন্য ডিজাইন করা হয়েছে।
`,
  },
  yue: {
    firstParagraph: '我接受 {interviewTerms} 同 {privacyPolicy}',
    firstParagraphRecording:
      '我同意喺呢次訪談中錄製{recordingType}，並同意將錄製內容分享畀研究客戶作研究用途。',
    firstParagraphTextOnly:
      '我同意參與呢次訪談，並同意將我嘅回答分享畀研究客戶作研究用途。',
    recordingVoice: '我嘅聲音',
    recordingVideo: '我嘅影片',
    recordingVoiceAndVideo: '我嘅聲音同影片',
    forReference: '供參考：',
    interviewTerms: '訪談條款',
    privacyPolicy: '私隱政策',
    translatePickLanguage: '揀你嘅語言，然後我哋開始。',
    letsGo: '開始啦',
    consentText: `## 歡迎!
呢個唔係普通嘅問卷。

呢個係互動式 AI 訪談，專為聽取你獨特嘅觀點而設計。
`,
  },
  ca: {
    firstParagraph: 'Accepto {interviewTerms} i {privacyPolicy}',
    firstParagraphRecording:
      "Dono el meu consentiment per a l'enregistrament de {recordingType} en aquesta entrevista i per compartir l'enregistrament amb el client de recerca per a fins de recerca.",
    firstParagraphTextOnly:
      "Dono el meu consentiment per participar en aquesta entrevista i per compartir les meves respostes amb el client de recerca per a fins de recerca.",
    recordingVoice: 'la meva veu',
    recordingVideo: 'el meu vídeo',
    recordingVoiceAndVideo: 'la meva veu i vídeo',
    forReference: 'Per a referència:',
    interviewTerms: "Termes de l'entrevista",
    privacyPolicy: 'Política de privacitat',
    translatePickLanguage: 'Tria el teu idioma i després començarem.',
    letsGo: 'Comencem',
    consentText: `## Benvingut!
Aquesta no és una enquesta típica.

És una entrevista interactiva amb IA, dissenyada per escoltar la teva perspectiva única.
`,
  },
  zh: {
    firstParagraph: '我接受{interviewTerms}和{privacyPolicy}',
    firstParagraphRecording:
      '我同意在本次访谈中录制{recordingType}，并同意将录制内容分享给研究客户用于研究目的。',
    firstParagraphTextOnly:
      '我同意参与本次访谈，并同意将我的回答分享给研究客户用于研究目的。',
    recordingVoice: '我的语音',
    recordingVideo: '我的视频',
    recordingVoiceAndVideo: '我的语音和视频',
    forReference: '供参考：',
    interviewTerms: '面试条款',
    privacyPolicy: '隐私政策',
    translatePickLanguage: '选择您的语言，然后我们就开始。',
    letsGo: '让我们开始吧',
    consentText: `## 欢迎！
这不是一项典型的调查。

这是一次互动式人工智能访谈，旨在倾听你独特的观点。
`,
  },
  'zh-TW': {
    firstParagraph: '我接受{interviewTerms}和{privacyPolicy}',
    firstParagraphRecording:
      '我同意在本次訪談中錄製{recordingType}，並同意將錄製內容分享給研究客戶用於研究目的。',
    firstParagraphTextOnly:
      '我同意參與本次訪談，並同意將我的回答分享給研究客戶用於研究目的。',
    recordingVoice: '我的語音',
    recordingVideo: '我的影片',
    recordingVoiceAndVideo: '我的語音和影片',
    forReference: '供參考：',
    interviewTerms: '訪談條款',
    privacyPolicy: '隱私政策',
    translatePickLanguage: '選擇您的語言，然後我們就開始。',
    letsGo: '讓我們開始吧',
    consentText: `## 歡迎！
這不是一項典型的調查。

這是一次互動式人工智慧訪談，旨在傾聽您獨特的觀點。
`,
  },
  hr: {
    firstParagraph: 'Prihvaćam {interviewTerms} i {privacyPolicy}',
    firstParagraphRecording:
      'Pristajem na snimanje {recordingType} u ovom intervjuu i na dijeljenje snimke s istraživačkim klijentom u istraživačke svrhe.',
    firstParagraphTextOnly:
      'Pristajem na sudjelovanje u ovom intervjuu i na dijeljenje mojih odgovora s istraživačkim klijentom u istraživačke svrhe.',
    recordingVoice: 'mog glasa',
    recordingVideo: 'mog videa',
    recordingVoiceAndVideo: 'mog glasa i videa',
    forReference: 'Za referencu:',
    interviewTerms: 'Uslovi intervjua',
    privacyPolicy: 'Politika privatnosti',
    translatePickLanguage: 'Odaberite svoj jezik, a zatim ćemo započeti.',
    letsGo: 'Krenimo',
    consentText: `## Dobrodošli!
Ovo nije tipična anketa.

Ovo je interaktivni AI intervju, dizajniran da čuje vašu jedinstvenu perspektivu.
`,
  },
  cs: {
    firstParagraph: 'Souhlasím s {interviewTerms} a {privacyPolicy}',
    firstParagraphRecording:
      'Souhlasím s nahráváním {recordingType} v tomto rozhovoru a se sdílením nahrávky s výzkumným klientem pro výzkumné účely.',
    firstParagraphTextOnly:
      'Souhlasím s účastí na tomto rozhovoru a se sdílením svých odpovědí s výzkumným klientem pro výzkumné účely.',
    recordingVoice: 'mého hlasu',
    recordingVideo: 'mého videa',
    recordingVoiceAndVideo: 'mého hlasu a videa',
    forReference: 'Pro informaci:',
    interviewTerms: 'Podmínky rozhovoru',
    privacyPolicy: 'Zásady ochrany osobních údajů',
    translatePickLanguage: 'Vyberte si svůj jazyk, a pak začneme.',
    letsGo: 'Začněme',
    consentText: `## Vítejte!
Toto není typický průzkum.

Toto je interaktivní AI rozhovor, navržený tak, aby vyslechl váš jedinečný pohled.
`,
  },
  da: {
    firstParagraph: 'Jeg accepterer {interviewTerms} og {privacyPolicy}',
    firstParagraphRecording:
      'Jeg samtykker til optagelse af {recordingType} i dette interview og til at dele optagelsen med forskningsklienten til forskningsformål.',
    firstParagraphTextOnly:
      'Jeg samtykker til at deltage i dette interview og til at dele mine svar med forskningsklienten til forskningsformål.',
    recordingVoice: 'min stemme',
    recordingVideo: 'min video',
    recordingVoiceAndVideo: 'min stemme og video',
    forReference: 'Til reference:',
    interviewTerms: 'Interviewvilkår',
    privacyPolicy: 'Fortrolighedspolitik',
    translatePickLanguage: 'Vælg dit sprog, og så begynder vi.',
    letsGo: 'Lad os begynde',
    consentText: `## Velkommen!
Dette er ikke en typisk undersøgelse.

Dette er et interaktivt AI-interview, designet til at høre dit unikke perspektiv.
`,
  },
  nl: {
    firstParagraph: 'Ik accepteer {interviewTerms} en {privacyPolicy}',
    firstParagraphRecording:
      'Ik geef toestemming voor de opname van {recordingType} in dit interview en voor het delen van de opname met de onderzoeksklant voor onderzoeksdoeleinden.',
    firstParagraphTextOnly:
      'Ik geef toestemming om deel te nemen aan dit interview en om mijn antwoorden te delen met de onderzoeksklant voor onderzoeksdoeleinden.',
    recordingVoice: 'mijn stem',
    recordingVideo: 'mijn video',
    recordingVoiceAndVideo: 'mijn stem en video',
    forReference: 'Ter referentie:',
    interviewTerms: 'Interviewvoorwaarden',
    privacyPolicy: 'Privacybeleid',
    translatePickLanguage: 'Kies je taal en dan beginnen we.',
    letsGo: 'Laten we beginnen',
    consentText: `## Welkom!
Dit is geen typische enquête.

Dit is een interactieve AI-interview, ontworpen om jouw unieke perspectief te horen.
`,
  },
  en: {
    firstParagraph: 'I accept {interviewTerms} and {privacyPolicy}',
    firstParagraphRecording:
      'I consent to the recording of {recordingType} in this interview and to sharing the recording with the research client for research purposes.',
    firstParagraphTextOnly:
      'I consent to participate in this interview and to sharing my responses with the research client for research purposes.',
    recordingVoice: 'my voice',
    recordingVideo: 'my video',
    recordingVoiceAndVideo: 'my voice and video',
    forReference: 'For reference:',
    interviewTerms: 'Interview Terms',
    privacyPolicy: 'Privacy Policy',
    translatePickLanguage: "Pick your language, and then we'll begin.",
    letsGo: "Let's go",
    consentText: `## Welcome.
### This isn't a survey — it's a conversation.
I'm an AI interviewer that listens like a human. I'll follow your lead, ask questions based on what you say, and help uncover what matters most.

**Here's how it works:**
- Just talk naturally — use your mic or camera to record your answers
- I'll ask follow-ups based on your answers
- There's no time limit, and longer answers help me understand you better

Your honest thoughts make this powerful. Thanks for sharing them.
`,
  },
  et: {
    firstParagraph: 'Ma nõustun {interviewTerms} ja {privacyPolicy}',
    firstParagraphRecording:
      'Nõustun {recordingType} salvestamisega selles intervjuus ja salvestuse jagamisega uurimiskliendiga uurimiseesmärkidel.',
    firstParagraphTextOnly:
      'Nõustun osalema selles intervjuus ja jagama oma vastuseid uurimiskliendiga uurimiseesmärkidel.',
    recordingVoice: 'minu hääle',
    recordingVideo: 'minu video',
    recordingVoiceAndVideo: 'minu hääle ja video',
    forReference: 'Viiteks:',
    interviewTerms: 'Intervjuu tingimused',
    privacyPolicy: 'Privaatsuspoliitika',
    translatePickLanguage: 'Valige oma keel ja siis alustame.',
    letsGo: 'Alustame',
    consentText: `## Tere tulemast!
See ei ole tavaline küsitlus.

See on interaktiivne tehisintellekti intervjuu, loodud selleks, et kuulda teie ainulaadset perspektiivi.
`,
  },
  fi: {
    firstParagraph: 'Hyväksyn {interviewTerms} ja {privacyPolicy}',
    firstParagraphRecording:
      'Suostun {recordingType} tallentamiseen tässä haastattelussa ja tallenteen jakamiseen tutkimusasiakkaan kanssa tutkimustarkoituksiin.',
    firstParagraphTextOnly:
      'Suostun osallistumaan tähän haastatteluun ja jakamaan vastaukseni tutkimusasiakkaan kanssa tutkimustarkoituksiin.',
    recordingVoice: 'ääneni',
    recordingVideo: 'videoni',
    recordingVoiceAndVideo: 'ääneni ja videoni',
    forReference: 'Viitteeksi:',
    interviewTerms: 'Haastatteluehdot',
    privacyPolicy: 'Tietosuojakäytäntö',
    translatePickLanguage: 'Valitse kielesi, niin aloitamme.',
    letsGo: 'Aloitetaan',
    consentText: `## Tervetuloa!
Tämä ei ole tavallinen kysely.

Tämä on interaktiivinen tekoälyhaastattelu, suunniteltu kuulemaan sinun ainutlaatuinen näkökulmasi.
`,
  },
  fr: {
    firstParagraph: "J'accepte {interviewTerms} et {privacyPolicy}",
    firstParagraphRecording:
      "Je consens à l'enregistrement de {recordingType} lors de cet entretien et au partage de l'enregistrement avec le client de recherche à des fins de recherche.",
    firstParagraphTextOnly:
      "Je consens à participer à cet entretien et au partage de mes réponses avec le client de recherche à des fins de recherche.",
    recordingVoice: 'ma voix',
    recordingVideo: 'ma vidéo',
    recordingVoiceAndVideo: 'ma voix et ma vidéo',
    forReference: 'Pour référence :',
    interviewTerms: "Conditions d'entretien",
    privacyPolicy: 'Politique de confidentialité',
    translatePickLanguage: 'Choisissez votre langue, puis nous commencerons.',
    letsGo: 'Commençons',
    consentText: `## Bienvenue !
Ce n'est pas un sondage classique.

Ceci est un entretien interactif avec une IA, conçu pour écouter votre perspective unique.
`,
  },
  gl: {
    firstParagraph: 'Acepto {interviewTerms} e {privacyPolicy}',
    firstParagraphRecording:
      'Consinto na gravación de {recordingType} nesta entrevista e en compartir a gravación co cliente de investigación con fins de investigación.',
    firstParagraphTextOnly:
      'Consinto en participar nesta entrevista e en compartir as miñas respostas co cliente de investigación con fins de investigación.',
    recordingVoice: 'a miña voz',
    recordingVideo: 'o meu vídeo',
    recordingVoiceAndVideo: 'a miña voz e vídeo',
    forReference: 'Para referencia:',
    interviewTerms: 'Termos da entrevista',
    privacyPolicy: 'Política de privacidade',
    translatePickLanguage: 'Escolle o teu idioma e logo comezaremos.',
    letsGo: 'Empecemos',
    consentText: `## Benvido!
Esta non é unha enquisa típica.

Esta é unha entrevista interactiva con IA, deseñada para escoitar a túa perspectiva única.
`,
  },
  de: {
    firstParagraph: 'Ich akzeptiere {interviewTerms} und {privacyPolicy}',
    firstParagraphRecording:
      'Ich stimme der Aufnahme von {recordingType} in diesem Interview und der Weitergabe der Aufnahme an den Forschungskunden zu Forschungszwecken zu.',
    firstParagraphTextOnly:
      'Ich stimme der Teilnahme an diesem Interview und der Weitergabe meiner Antworten an den Forschungskunden zu Forschungszwecken zu.',
    recordingVoice: 'meiner Stimme',
    recordingVideo: 'meinem Video',
    recordingVoiceAndVideo: 'meiner Stimme und meinem Video',
    forReference: 'Zur Information:',
    interviewTerms: 'Interviewbedingungen',
    privacyPolicy: 'Datenschutzrichtlinie',
    translatePickLanguage: 'Wählen Sie Ihre Sprache, und dann beginnen wir.',
    letsGo: 'Lass uns anfangen',
    consentText: `## Willkommen!
Dies ist keine typische Umfrage.

Dies ist ein interaktives KI-Interview, das darauf ausgelegt ist, deine einzigartige Perspektive zu hören.
`,
  },
  el: {
    firstParagraph: 'Αποδέχομαι {interviewTerms} και {privacyPolicy}',
    firstParagraphRecording:
      'Συναινώ στην εγγραφή {recordingType} σε αυτή τη συνέντευξη και στην κοινοποίηση της εγγραφής στον ερευνητικό πελάτη για ερευνητικούς σκοπούς.',
    firstParagraphTextOnly:
      'Συναινώ στη συμμετοχή μου σε αυτή τη συνέντευξη και στην κοινοποίηση των απαντήσεών μου στον ερευνητικό πελάτη για ερευνητικούς σκοπούς.',
    recordingVoice: 'της φωνής μου',
    recordingVideo: 'του βίντεό μου',
    recordingVoiceAndVideo: 'της φωνής και του βίντεό μου',
    forReference: 'Για αναφορά:',
    interviewTerms: 'Όροι συνέντευξης',
    privacyPolicy: 'Πολιτική απορρήτου',
    translatePickLanguage: 'Επιλέξτε τη γλώσσα σας και στη συνέχεια θα ξεκινήσουμε.',
    letsGo: 'Ας ξεκινήσουμε',
    consentText: `## Καλώς ήρθατε!
Αυτή δεν είναι μια τυπική έρευνα.

Πρόκειται για μια διαδραστική συνέντευξη με τεχνητή νοημοσύνη, σχεδιασμένη για να ακούσει τη μοναδική σας οπτική.
`,
  },
  he: {
    firstParagraph: 'אני מקבל {interviewTerms} ו {privacyPolicy}',
    firstParagraphRecording:
      'אני מסכים/ה להקלטת {recordingType} בראיון זה ולשיתוף ההקלטה עם לקוח המחקר למטרות מחקר.',
    firstParagraphTextOnly:
      'אני מסכים/ה להשתתף בראיון זה ולשתף את תשובותיי עם לקוח המחקר למטרות מחקר.',
    recordingVoice: 'קולי',
    recordingVideo: 'הווידאו שלי',
    recordingVoiceAndVideo: 'קולי והווידאו שלי',
    forReference: 'לעיון:',
    interviewTerms: 'תנאי הראיון',
    privacyPolicy: 'מדיניות פרטיות',
    translatePickLanguage: 'בחר את השפה שלך, ואז נתחיל.',
    letsGo: 'בואו נתחיל',
    consentText: `## ברוכים הבאים!
זו לא סקר רגיל.

זו ראיון אינטראקטיבי עם בינה מלאכותית, שנועד לשמוע את נקודת המבט הייחודית שלך.
`,
  },
  hi: {
    firstParagraph: 'मैं {interviewTerms} और {privacyPolicy} को स्वीकार करता हूँ',
    firstParagraphRecording:
      'मैं इस साक्षात्कार में {recordingType} की रिकॉर्डिंग और अनुसंधान उद्देश्यों के लिए अनुसंधान ग्राहक के साथ रिकॉर्डिंग साझा करने के लिए सहमत हूँ।',
    firstParagraphTextOnly:
      'मैं इस साक्षात्कार में भाग लेने और अनुसंधान उद्देश्यों के लिए अनुसंधान ग्राहक के साथ अपने उत्तर साझा करने के लिए सहमत हूँ।',
    recordingVoice: 'मेरी आवाज़',
    recordingVideo: 'मेरे वीडियो',
    recordingVoiceAndVideo: 'मेरी आवाज़ और वीडियो',
    forReference: 'संदर्भ के लिए:',
    interviewTerms: 'साक्षात्कार की शर्तें',
    privacyPolicy: 'गोपनीयता नीति',
    translatePickLanguage: 'अपनी भाषा चुनें, और फिर हम शुरू करेंगे।',
    letsGo: 'आइए शुरू करें',
    consentText: `## स्वागत है!
यह कोई साधारण सर्वेक्षण नहीं है।

यह एक इंटरैक्टिव एआई इंटरव्यू है, जिसे आपकी अनूठी दृष्टिकोण सुनने के लिए डिज़ाइन किया गया है।
`,
  },
  hu: {
    firstParagraph: 'Elfogadom a(z) {interviewTerms} és {privacyPolicy}',
    firstParagraphRecording:
      'Hozzájárulok {recordingType} rögzítéséhez ebben az interjúban, és a felvétel megosztásához a kutatási ügyféllel kutatási célokra.',
    firstParagraphTextOnly:
      'Hozzájárulok az interjúban való részvételhez és válaszaim megosztásához a kutatási ügyféllel kutatási célokra.',
    recordingVoice: 'a hangom',
    recordingVideo: 'a videóm',
    recordingVoiceAndVideo: 'a hangom és videóm',
    forReference: 'Tájékoztatásul:',
    interviewTerms: 'Interjú feltételei',
    privacyPolicy: 'Adatvédelmi irányelvek',
    translatePickLanguage: 'Válassza ki a nyelvét, és akkor kezdünk.',
    letsGo: 'Kezdjük',
    consentText: `## Üdvözöljük!
Ez nem egy tipikus felmérés.

Ez egy interaktív AI-interjú, amelyet az Ön egyedi nézőpontjának meghallgatására terveztek.
`,
  },
  is: {
    firstParagraph: 'Ég samþykki {interviewTerms} og {privacyPolicy}',
    firstParagraphRecording:
      'Ég samþykki upptöku á {recordingType} í þessu viðtali og að deila upptökunni með rannsóknarviðskiptavininum í rannsóknarskyni.',
    firstParagraphTextOnly:
      'Ég samþykki að taka þátt í þessu viðtali og að deila svörum mínum með rannsóknarviðskiptavininum í rannsóknarskyni.',
    recordingVoice: 'rödd minni',
    recordingVideo: 'myndbandi mínu',
    recordingVoiceAndVideo: 'rödd og myndbandi mínu',
    forReference: 'Til viðmiðunar:',
    interviewTerms: 'Viðtalskjör',
    privacyPolicy: 'Persónuverndarstefna',
    translatePickLanguage: 'Veldu tungumálið þitt, og þá byrjum við.',
    letsGo: 'Byrjum við',
    consentText: `## Velkomin!
Þetta er ekki hefðbundin könnun.

Þetta er gagnvirk AI viðtal, hannað til að hlusta á þitt einstaka sjónarhorn.
`,
  },
  id: {
    firstParagraph: 'Saya menerima {interviewTerms} dan {privacyPolicy}',
    firstParagraphRecording:
      'Saya menyetujui perekaman {recordingType} dalam wawancara ini dan berbagi rekaman dengan klien riset untuk tujuan penelitian.',
    firstParagraphTextOnly:
      'Saya menyetujui untuk berpartisipasi dalam wawancara ini dan berbagi jawaban saya dengan klien riset untuk tujuan penelitian.',
    recordingVoice: 'suara saya',
    recordingVideo: 'video saya',
    recordingVoiceAndVideo: 'suara dan video saya',
    forReference: 'Untuk referensi:',
    interviewTerms: 'Syarat Wawancara',
    privacyPolicy: 'Kebijakan Privasi',
    translatePickLanguage: 'Pilih bahasa Anda, lalu kita akan mulai.',
    letsGo: 'Mari kita mulai',
    consentText: `## Selamat datang!
Ini bukan survei biasa.

Ini adalah wawancara AI interaktif, dirancang untuk mendengarkan perspektif unik Anda.
`,
  },
  it: {
    firstParagraph: 'Accetto {interviewTerms} e {privacyPolicy}',
    firstParagraphRecording:
      'Acconsento alla registrazione di {recordingType} in questa intervista e alla condivisione della registrazione con il cliente di ricerca a scopi di ricerca.',
    firstParagraphTextOnly:
      'Acconsento a partecipare a questa intervista e a condividere le mie risposte con il cliente di ricerca a scopi di ricerca.',
    recordingVoice: 'la mia voce',
    recordingVideo: 'il mio video',
    recordingVoiceAndVideo: 'la mia voce e il mio video',
    forReference: 'Per riferimento:',
    interviewTerms: 'Termini del colloquio',
    privacyPolicy: 'Politica sulla riservatezza',
    translatePickLanguage: 'Scegli la tua lingua e poi inizieremo.',
    letsGo: 'Cominciamo',
    consentText: `## Benvenuto!
Questo non è un sondaggio tipico.

Questa è un'intervista interattiva con l'IA, progettata per ascoltare la tua prospettiva unica.
`,
  },
  ja: {
    firstParagraph: '私は{interviewTerms}と{privacyPolicy}に同意します',
    firstParagraphRecording:
      'このインタビューにおける{recordingType}の録音・録画、および調査目的で調査クライアントと録音・録画を共有することに同意します。',
    firstParagraphTextOnly:
      'このインタビューへの参加、および調査目的で調査クライアントと回答を共有することに同意します。',
    recordingVoice: '音声',
    recordingVideo: '映像',
    recordingVoiceAndVideo: '音声と映像',
    forReference: '参考：',
    interviewTerms: 'インタビューポリシー',
    privacyPolicy: 'プライバシーポリシー',
    translatePickLanguage: '言語を選んでから始めましょう。',
    letsGo: '始めましょう',
    consentText: `## ようこそ！
これは典型的なアンケートではありません。

これは、あなたのユニークな視点を聞くために設計されたインタラクティブなAIインタビューです。
`,
  },
  ka: {
    firstParagraph: 'ვეთანხმები {interviewTerms} და {privacyPolicy}',
    firstParagraphRecording:
      'ვეთანხმები {recordingType} ჩაწერას ამ ინტერვიუში და ჩანაწერის გაზიარებას კვლევის კლიენტთან კვლევითი მიზნებისთვის.',
    firstParagraphTextOnly:
      'ვეთანხმები ამ ინტერვიუში მონაწილეობას და ჩემი პასუხების გაზიარებას კვლევის კლიენტთან კვლევითი მიზნებისთვის.',
    recordingVoice: 'ჩემი ხმის',
    recordingVideo: 'ჩემი ვიდეოს',
    recordingVoiceAndVideo: 'ჩემი ხმისა და ვიდეოს',
    forReference: 'მითითებისთვის:',
    interviewTerms: 'ინტერვიუს პირობები',
    privacyPolicy: 'კონფიდენციალურობის პოლიტიკა',
    translatePickLanguage: 'აირჩიეთ თქვენი ენა და შემდეგ დავიწყებთ.',
    letsGo: 'დავიწყოთ',
    consentText: `## მოგესალმებით!
ეს არ არის ჩვეულებრივი გამოკითხვა.

ეს არის ინტერაქტიული AI ინტერვიუ, რომელიც შექმნილია თქვენი უნიკალური შეხედულების მოსასმენად.
`,
  },
  kn: {
    firstParagraph: 'ನಾನು {interviewTerms} ಮತ್ತು {privacyPolicy} ಒಪ್ಪಿಗೆಯಾದೇನೆ',
    firstParagraphRecording:
      'ಈ ಸಂದರ್ಶನದಲ್ಲಿ {recordingType} ರೆಕಾರ್ಡಿಂಗ್ ಮತ್ತು ಸಂಶೋಧನಾ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಸಂಶೋಧನಾ ಗ್ರಾಹಕರೊಂದಿಗೆ ರೆಕಾರ್ಡಿಂಗ್ ಹಂಚಿಕೊಳ್ಳಲು ಒಪ್ಪಿಗೆಯಾದೇನೆ.',
    firstParagraphTextOnly:
      'ಈ ಸಂದರ್ಶನದಲ್ಲಿ ಭಾಗವಹಿಸಲು ಮತ್ತು ಸಂಶೋಧನಾ ಉದ್ದೇಶಗಳಿಗಾಗಿ ನನ್ನ ಉತ್ತರಗಳನ್ನು ಸಂಶೋಧನಾ ಗ್ರಾಹಕರೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳಲು ಒಪ್ಪಿಗೆಯಾದೇನೆ.',
    recordingVoice: 'ನನ್ನ ಧ್ವನಿಯ',
    recordingVideo: 'ನನ್ನ ವೀಡಿಯೊದ',
    recordingVoiceAndVideo: 'ನನ್ನ ಧ್ವನಿ ಮತ್ತು ವೀಡಿಯೊದ',
    forReference: 'ಉಲ್ಲೇಖಕ್ಕಾಗಿ:',
    interviewTerms: 'ಮೂಲಕ ನಿಯಮಗಳು',
    privacyPolicy: 'ಗೌಪ್ಯತಾ ನೀತಿ',
    translatePickLanguage: 'ನಿಮ್ಮ ಭಾಷೆಯನ್ನು ಆರಿಸಿ, ನಂತರ ನಾವು ಪ್ರಾರಂಭಿಸುತ್ತೇವೆ.',
    letsGo: 'ಪ್ರಾರಂಭಿಸೋಣ',
    consentText: `## ಸ್ವಾಗತ!
ಇದು ಸಾಮಾನ್ಯ ಸಮೀಕ್ಷೆ ಅಲ್ಲ.

ಇದು ನಿಮ್ಮ ವಿಶಿಷ್ಟ ದೃಷ್ಟಿಕೋನವನ್ನು ಕೇಳಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿರುವ ಇಂಟರ್ಯಾಕ್ಟಿವ್ AI ಸಂದರ್ಶನವಾಗಿದೆ.
`,
  },
  kk: {
    firstParagraph: 'Мен {interviewTerms} және {privacyPolicy} келісемін',
    firstParagraphRecording:
      'Мен осы сұхбатта {recordingType} жазуға және жазбаны зерттеу клиентімен зерттеу мақсатында бөлісуге келісемін.',
    firstParagraphTextOnly:
      'Мен осы сұхбатқа қатысуға және жауаптарымды зерттеу клиентімен зерттеу мақсатында бөлісуге келісемін.',
    recordingVoice: 'дауысымның',
    recordingVideo: 'бейнемнің',
    recordingVoiceAndVideo: 'дауысым мен бейнемнің',
    forReference: 'Анықтама үшін:',
    interviewTerms: 'Сұхбат шарттары',
    privacyPolicy: 'Құпиялылық саясаты',
    translatePickLanguage: 'Тіліңізді таңдаңыз, содан кейін біз бастаймыз.',
    letsGo: 'Бастау',
    consentText: `## Қош келдіңіз!
Бұл кәдімгі сауалнама емес.

Бұл сіздің ерекше көзқарасыңызды тыңдау үшін жасалған интерактивті ЖИ сұхбаты.
`,
  },
  ko: {
    firstParagraph: '저는 {interviewTerms}와 {privacyPolicy}에 동의합니다',
    firstParagraphRecording:
      '본 인터뷰에서 {recordingType} 녹음/녹화 및 연구 목적으로 연구 고객과 녹음/녹화를 공유하는 것에 동의합니다.',
    firstParagraphTextOnly:
      '본 인터뷰에 참여하고 연구 목적으로 연구 고객과 답변을 공유하는 것에 동의합니다.',
    recordingVoice: '제 음성',
    recordingVideo: '제 영상',
    recordingVoiceAndVideo: '제 음성 및 영상',
    forReference: '참고:',
    interviewTerms: '인터뷰 약관',
    privacyPolicy: '개인정보 처리방침',
    translatePickLanguage: '언어를 선택하면 시작합니다.',
    letsGo: '시작해봅시다',
    consentText: `## 환영합니다!
이것은 일반적인 설문조사가 아닙니다.

이는 여러분의 독특한 관점을 듣기 위해 설계된 인터랙티브 AI 인터뷰입니다.
`,
  },
  lv: {
    firstParagraph: 'Es piekrītu {interviewTerms} un {privacyPolicy}',
    firstParagraphRecording:
      'Es piekrītu {recordingType} ierakstīšanai šajā intervijā un ieraksta kopīgošanai ar pētniecības klientu pētniecības nolūkos.',
    firstParagraphTextOnly:
      'Es piekrītu piedalīties šajā intervijā un dalīties ar savām atbildēm ar pētniecības klientu pētniecības nolūkos.',
    recordingVoice: 'manas balss',
    recordingVideo: 'mana video',
    recordingVoiceAndVideo: 'manas balss un video',
    forReference: 'Uzziņai:',
    interviewTerms: 'Intervijas noteikumi',
    privacyPolicy: 'Privātuma politika',
    translatePickLanguage: 'Izvēlieties savu valodu, un tad mēs sāksim.',
    letsGo: 'Sāksim',
    consentText: `## Laipni lūdzam!
  Šis nav parasts aptaujas veids.

  Šī ir interaktīva AI intervija, izveidota, lai dzirdētu jūsu unikālo skatījumu.
  `,
  },
  lt: {
    firstParagraph: 'Aš sutinku su {interviewTerms} ir {privacyPolicy}',
    firstParagraphRecording:
      'Sutinku su {recordingType} įrašymu šiame interviu ir įrašo dalijimusi su tyrimų klientu tyrimų tikslais.',
    firstParagraphTextOnly:
      'Sutinku dalyvauti šiame interviu ir dalintis savo atsakymais su tyrimų klientu tyrimų tikslais.',
    recordingVoice: 'mano balso',
    recordingVideo: 'mano vaizdo',
    recordingVoiceAndVideo: 'mano balso ir vaizdo',
    forReference: 'Informacijai:',
    interviewTerms: 'Interviu sąlygos',
    privacyPolicy: 'Privatumo politika',
    translatePickLanguage: 'Pasirinkite savo kalbą, o tada pradėsime.',
    letsGo: 'Pradėkime',
    consentText: `## Sveiki atvykę!
Tai nėra įprasta apklausa.

Tai interaktyvus dirbtinio intelekto interviu, skirtas išgirsti jūsų unikalų požiūrį.
`,
  },
  mk: {
    firstParagraph: 'Прифатам {interviewTerms} и {privacyPolicy}',
    firstParagraphRecording:
      'Се согласувам со снимањето на {recordingType} во ова интервју и со споделувањето на снимката со истражувачкиот клиент за истражувачки цели.',
    firstParagraphTextOnly:
      'Се согласувам да учествувам во ова интервју и да ги споделам моите одговори со истражувачкиот клиент за истражувачки цели.',
    recordingVoice: 'мојот глас',
    recordingVideo: 'моето видео',
    recordingVoiceAndVideo: 'мојот глас и видео',
    forReference: 'За референца:',
    interviewTerms: 'Услови за интервју',
    privacyPolicy: 'Политика за приватност',
    translatePickLanguage: 'Изберете го вашиот јазик, а потоа ќе започнеме.',
    letsGo: 'Да започнеме',
    consentText: `## Добредојдовте!
Ова не е типична анкета.

Ова е интерактивно AI интервју, дизајнирано да го слушне вашиот уникатен поглед.
`,
  },
  ms: {
    firstParagraph: 'Saya terima {interviewTerms} dan {privacyPolicy}',
    firstParagraphRecording:
      'Saya bersetuju dengan rakaman {recordingType} dalam temu bual ini dan berkongsi rakaman dengan klien penyelidikan untuk tujuan penyelidikan.',
    firstParagraphTextOnly:
      'Saya bersetuju untuk menyertai temu bual ini dan berkongsi jawapan saya dengan klien penyelidikan untuk tujuan penyelidikan.',
    recordingVoice: 'suara saya',
    recordingVideo: 'video saya',
    recordingVoiceAndVideo: 'suara dan video saya',
    forReference: 'Untuk rujukan:',
    interviewTerms: 'Terma Wawancara',
    privacyPolicy: 'Dasar Privasi',
    translatePickLanguage: 'Pilih bahasa anda, dan kemudian kami akan mula.',
    letsGo: 'Mari mula',
    consentText: `## Selamat datang!
Ini bukan tinjauan biasa.

Ini adalah temu bual AI interaktif, direka untuk mendengar perspektif unik anda.
`,
  },
  mi: {
    firstParagraph: 'Kei te whakaae au ki {interviewTerms} me {privacyPolicy}',
    firstParagraphRecording:
      'Ka whakaae au ki te hopunga o {recordingType} i tēnei uiui me te tiri i te hopunga ki te kiritaki rangahau mō ngā kaupapa rangahau.',
    firstParagraphTextOnly:
      'Ka whakaae au ki te whai wāhi ki tēnei uiui me te tiri i aku whakautu ki te kiritaki rangahau mō ngā kaupapa rangahau.',
    recordingVoice: 'tōku reo',
    recordingVideo: 'tōku ataata',
    recordingVoiceAndVideo: 'tōku reo me te ataata',
    forReference: 'Hei tohutoro:',
    interviewTerms: 'Ngā tikanga uiui',
    privacyPolicy: 'Ture Tūmataiti',
    translatePickLanguage: 'Tīpakohia tō reo, kātahi ka tīmata tātou.',
    letsGo: 'Tīmataratanga',
    consentText: `## Nau mai!
Ehara tēnei i te rangahau noa.

He uiui AI pāhekoheko tēnei, i hangaia hei whakarongo ki tō tirohanga ahurei.
`,
  },
  mr: {
    firstParagraph: 'मी {interviewTerms} आणि {privacyPolicy} स्वीकारतो',
    firstParagraphRecording:
      'या मुलाखतीत {recordingType} रेकॉर्डिंग आणि संशोधन उद्देशांसाठी संशोधन ग्राहकासोबत रेकॉर्डिंग शेअर करण्यास मी सहमत आहे.',
    firstParagraphTextOnly:
      'या मुलाखतीत सहभागी होण्यास आणि संशोधन उद्देशांसाठी संशोधन ग्राहकासोबत माझे उत्तरे शेअर करण्यास मी सहमत आहे.',
    recordingVoice: 'माझ्या आवाजाचे',
    recordingVideo: 'माझ्या व्हिडिओचे',
    recordingVoiceAndVideo: 'माझ्या आवाज आणि व्हिडिओचे',
    forReference: 'संदर्भासाठी:',
    interviewTerms: 'साक्षात्कार अटी',
    privacyPolicy: 'गोपनीयता धोरण',
    translatePickLanguage: 'तुमची भाषा निवडा, आणि मग आपण सुरुवात करू.',
    letsGo: 'आपल्या आरंभा',
    consentText: `## स्वागत आहे!
  हे एखादे साधारण सर्वेक्षण नाही.

  हे एक संवादात्मक AI मुलाखत आहे, जे तुमच्या अनन्य दृष्टिकोनाला ऐकण्यासाठी डिझाइन केले आहे.
  `,
  },
  ne: {
    firstParagraph: 'म माने {interviewTerms} र {privacyPolicy} स्वीकार गर्छु',
    firstParagraphRecording:
      'यो अन्तरवार्तामा {recordingType} रेकर्डिङ र अनुसन्धान उद्देश्यका लागि अनुसन्धान ग्राहकसँग रेकर्डिङ साझा गर्न म सहमत छु।',
    firstParagraphTextOnly:
      'यो अन्तरवार्तामा सहभागी हुन र अनुसन्धान उद्देश्यका लागि अनुसन्धान ग्राहकसँग मेरा जवाफ साझा गर्न म सहमत छु।',
    recordingVoice: 'मेरो आवाजको',
    recordingVideo: 'मेरो भिडियोको',
    recordingVoiceAndVideo: 'मेरो आवाज र भिडियोको',
    forReference: 'सन्दर्भको लागि:',
    interviewTerms: 'साक्षात्कारका सर्तहरू',
    privacyPolicy: 'गोपनीयता नीति',
    translatePickLanguage: 'तपाईंको भाषा छान्नुहोस्, अनि हामी सुरु गर्नेछौं।',
    letsGo: 'हामी सुरु गरौं',
    consentText: `## स्वागत छ!
  यो सामान्य सर्वेक्षण होइन।

  यो एक अन्तरक्रियात्मक एआई अन्तरवार्ता हो, तपाईंको अद्वितीय दृष्टिकोण सुन्न डिजाइन गरिएको।
  `,
  },
  no: {
    firstParagraph: 'Jeg aksepterer {interviewTerms} og {privacyPolicy}',
    firstParagraphRecording:
      'Jeg samtykker til opptak av {recordingType} i dette intervjuet og til å dele opptaket med forskningsklienten for forskningsformål.',
    firstParagraphTextOnly:
      'Jeg samtykker til å delta i dette intervjuet og til å dele mine svar med forskningsklienten for forskningsformål.',
    recordingVoice: 'stemmen min',
    recordingVideo: 'videoen min',
    recordingVoiceAndVideo: 'stemmen og videoen min',
    forReference: 'Til referanse:',
    interviewTerms: 'Intervjuforhold',
    privacyPolicy: 'Personvernpolitikk',
    translatePickLanguage: 'Velg språket ditt, og så begynner vi.',
    letsGo: 'La oss begynne',
    consentText: `## Velkommen!
  Dette er ikke en typisk undersøkelse.

  Dette er et interaktivt AI-intervju, designet for å høre ditt unike perspektiv.
  `,
  },
  pa: {
    firstParagraph: 'ਮੈਂ {interviewTerms} ਅਤੇ {privacyPolicy} ਨੂੰ ਸਵੀਕਾਰ ਕਰਦਾ ਹਾਂ',
    firstParagraphRecording:
      'ਮੈਂ ਇਸ ਇੰਟਰਵਿਊ ਵਿੱਚ {recordingType} ਦੀ ਰਿਕਾਰਡਿੰਗ ਅਤੇ ਖੋਜ ਉਦੇਸ਼ਾਂ ਲਈ ਖੋਜ ਗਾਹਕ ਨਾਲ ਰਿਕਾਰਡਿੰਗ ਸਾਂਝੀ ਕਰਨ ਲਈ ਸਹਿਮਤ ਹਾਂ।',
    firstParagraphTextOnly:
      'ਮੈਂ ਇਸ ਇੰਟਰਵਿਊ ਵਿੱਚ ਹਿੱਸਾ ਲੈਣ ਅਤੇ ਖੋਜ ਉਦੇਸ਼ਾਂ ਲਈ ਖੋਜ ਗਾਹਕ ਨਾਲ ਆਪਣੇ ਜਵਾਬ ਸਾਂਝੇ ਕਰਨ ਲਈ ਸਹਿਮਤ ਹਾਂ।',
    recordingVoice: 'ਮੇਰੀ ਆਵਾਜ਼',
    recordingVideo: 'ਮੇਰੇ ਵੀਡੀਓ',
    recordingVoiceAndVideo: 'ਮੇਰੀ ਆਵਾਜ਼ ਅਤੇ ਵੀਡੀਓ',
    forReference: 'ਹਵਾਲੇ ਲਈ:',
    interviewTerms: 'ਸਾক্ষਾਤਕਾਰ ਦੀਆਂ ਸ਼ਰਤਾਂ',
    privacyPolicy: 'ਪਰਾਈਵੇਟ ਨੀਤੀ',
    translatePickLanguage: 'ਆਪਣੀ ਭਾਸ਼ਾ ਚੁਣੋ, ਅਤੇ ਫਿਰ ਅਸੀਂ ਸ਼ੁਰੂ ਕਰਾਂਗੇ।',
    letsGo: 'ਸ਼ੁਰੂ ਕਰੀਏ',
    consentText: `## ਸੁਆਗਤ ਹੈ!
  ਇਹ ਕੋਈ ਆਮ ਸਰਵੇਖਣ ਨਹੀਂ ਹੈ।

  ਇਹ ਇੱਕ ਇੰਟਰਐਕਟਿਵ ਏਆਈ ਇੰਟਰਵਿਊ ਹੈ, ਜੋ ਤੁਹਾਡੇ ਵਿਲੱਖਣ ਨਜ਼ਰੀਏ ਨੂੰ ਸੁਣਨ ਲਈ ਡਿਜ਼ਾਇਨ ਕੀਤਾ ਗਿਆ ਹੈ।
  `,
  },
  fa: {
    firstParagraph: 'من {interviewTerms} و {privacyPolicy} را می‌پذیرم',
    firstParagraphRecording:
      'من با ضبط {recordingType} در این مصاحبه و به اشتراک‌گذاری ضبط با مشتری تحقیقاتی برای اهداف پژوهشی موافقم.',
    firstParagraphTextOnly:
      'من با شرکت در این مصاحبه و به اشتراک‌گذاری پاسخ‌هایم با مشتری تحقیقاتی برای اهداف پژوهشی موافقم.',
    recordingVoice: 'صدای من',
    recordingVideo: 'ویدیوی من',
    recordingVoiceAndVideo: 'صدا و ویدیوی من',
    forReference: 'برای مرجع:',
    interviewTerms: 'شرایط مصاحبه',
    privacyPolicy: 'سیاست حفظ حریم خصوصی',
    translatePickLanguage: 'زبان خود را انتخاب کنید، سپس شروع می‌کنیم.',
    letsGo: 'بیا شروع کنیم',
    consentText: `## خوش آمدید!
این یک نظرسنجی معمولی نیست.

این یک مصاحبه تعاملی با هوش مصنوعی است که برای شنیدن دیدگاه منحصربه‌فرد شما طراحی شده است.
`,
  },
  pl: {
    firstParagraph: 'Akceptuję {interviewTerms} i {privacyPolicy}',
    firstParagraphRecording:
      'Wyrażam zgodę na nagrywanie {recordingType} podczas tego wywiadu oraz na udostępnienie nagrania klientowi badawczemu w celach badawczych.',
    firstParagraphTextOnly:
      'Wyrażam zgodę na udział w tym wywiadzie oraz na udostępnienie moich odpowiedzi klientowi badawczemu w celach badawczych.',
    recordingVoice: 'mojego głosu',
    recordingVideo: 'mojego wideo',
    recordingVoiceAndVideo: 'mojego głosu i wideo',
    forReference: 'Dla odniesienia:',
    interviewTerms: 'Warunki rozmowy kwalifikacyjnej',
    privacyPolicy: 'Polityka prywatności',
    translatePickLanguage: 'Wybierz swój język, a następnie zaczniemy.',
    letsGo: 'Zacznijmy',
    consentText: `## Witaj!
To nie jest typowa ankieta.

To interaktywny wywiad z AI, zaprojektowany, aby usłyszeć Twoją unikalną perspektywę.
`,
  },
  pt: {
    firstParagraph: 'Aceito os {interviewTerms} e a {privacyPolicy}',
    firstParagraphRecording:
      'Consinto a gravação de {recordingType} nesta entrevista e a partilha da gravação com o cliente de investigação para fins de investigação.',
    firstParagraphTextOnly:
      'Consinto participar nesta entrevista e partilhar as minhas respostas com o cliente de investigação para fins de investigação.',
    recordingVoice: 'a minha voz',
    recordingVideo: 'o meu vídeo',
    recordingVoiceAndVideo: 'a minha voz e vídeo',
    forReference: 'Para referência:',
    interviewTerms: 'Termos da entrevista',
    privacyPolicy: 'Política de privacidade',
    translatePickLanguage: 'Escolha o seu idioma e depois começaremos.',
    letsGo: 'Vamos começar',
    consentText: `## Bem-vindo.
### Isto não é um inquérito — é uma conversa.
Sou um entrevistador de IA que ouve como uma pessoa. Vou acompanhar o teu ritmo, fazer perguntas com base no que dizes e ajudar-te a descobrir o que é mais importante para ti.

**Vê como funciona:**
- Fala naturalmente — usa o teu microfone ou câmara para gravar as tuas respostas
- Farei perguntas de seguimento com base nas tuas respostas
- Não há limite de tempo, e respostas mais detalhadas ajudam-me a compreender-te melhor

A tua honestidade torna isto valioso. Obrigado por a partilhares.
`,
  },
  ro: {
    firstParagraph: 'Accept {interviewTerms} și {privacyPolicy}',
    firstParagraphRecording:
      'Sunt de acord cu înregistrarea {recordingType} în acest interviu și cu partajarea înregistrării cu clientul de cercetare în scopuri de cercetare.',
    firstParagraphTextOnly:
      'Sunt de acord să particip la acest interviu și să împărtășesc răspunsurile mele cu clientul de cercetare în scopuri de cercetare.',
    recordingVoice: 'vocii mele',
    recordingVideo: 'videoclipului meu',
    recordingVoiceAndVideo: 'vocii și videoclipului meu',
    forReference: 'Pentru referință:',
    interviewTerms: 'Termeni de interviu',
    privacyPolicy: 'Politica de confidențialitate',
    translatePickLanguage: 'Alegeți limba dvs., apoi vom începe.',
    letsGo: 'Să începem',
    consentText: `## Bun venit!
Aceasta nu este un sondaj obișnuit.

Aceasta este un interviu interactiv cu AI, conceput pentru a asculta perspectiva ta unică.
`,
  },
  ru: {
    firstParagraph: 'Я принимаю {interviewTerms} и {privacyPolicy}',
    firstParagraphRecording:
      'Я даю согласие на запись {recordingType} в этом интервью и на предоставление записи исследовательскому клиенту в исследовательских целях.',
    firstParagraphTextOnly:
      'Я даю согласие на участие в этом интервью и на предоставление моих ответов исследовательскому клиенту в исследовательских целях.',
    recordingVoice: 'моего голоса',
    recordingVideo: 'моего видео',
    recordingVoiceAndVideo: 'моего голоса и видео',
    forReference: 'Для справки:',
    interviewTerms: 'Условия собеседования',
    privacyPolicy: 'Политика конфиденциальности',
    translatePickLanguage: 'Выберите ваш язык, а затем мы начнем.',
    letsGo: 'Давайте начнем',
    consentText: `## Добро пожаловать!
Это не обычный опрос.

Это интерактивное интервью с ИИ, созданное для того, чтобы услышать вашу уникальную точку зрения.
`,
  },
  sr: {
    firstParagraph: 'Прихватам {interviewTerms} и {privacyPolicy}',
    firstParagraphRecording:
      'Пристајем на снимање {recordingType} у овом интервјуу и на дељење снимка са истраживачким клијентом у истраживачке сврхе.',
    firstParagraphTextOnly:
      'Пристајем на учешће у овом интервјуу и на дељење мојих одговора са истраживачким клијентом у истраживачке сврхе.',
    recordingVoice: 'мог гласа',
    recordingVideo: 'мог видеа',
    recordingVoiceAndVideo: 'мог гласа и видеа',
    forReference: 'За референцу:',
    interviewTerms: 'Услови интервјуа',
    privacyPolicy: 'Политика приватности',
    translatePickLanguage: 'Изаберите свој језик, а онда ћемо почети.',
    letsGo: 'Хајде да почнемо',
    consentText: `## Добродошли!
Ово није типична анкета.

Ово је интерактивни AI интервју, дизајниран да чује вашу јединствену перспективу.
`,
  },
  sk: {
    firstParagraph: 'Súhlasím s {interviewTerms} a {privacyPolicy}',
    firstParagraphRecording:
      'Súhlasím s nahrávaním {recordingType} v tomto rozhovore a so zdieľaním nahrávky s výskumným klientom na výskumné účely.',
    firstParagraphTextOnly:
      'Súhlasím s účasťou na tomto rozhovore a so zdieľaním mojich odpovedí s výskumným klientom na výskumné účely.',
    recordingVoice: 'môjho hlasu',
    recordingVideo: 'môjho videa',
    recordingVoiceAndVideo: 'môjho hlasu a videa',
    forReference: 'Pre informáciu:',
    interviewTerms: 'Podmienky pohovoru',
    privacyPolicy: 'Zásady ochrany osobných údajov',
    translatePickLanguage: 'Vyberte si svoj jazyk a potom začneme.',
    letsGo: 'Začnime',
    consentText: `## Vitajte!
Toto nie je typický prieskum.

Toto je interaktívny AI rozhovor, navrhnutý tak, aby vypočul váš jedinečný pohľad.
`,
  },
  sl: {
    firstParagraph: 'Sprejem {interviewTerms} in {privacyPolicy}',
    firstParagraphRecording:
      'Soglašam s snemanjem {recordingType} v tem intervjuju in z delitvijo posnetka z raziskovalnim naročnikom za raziskovalne namene.',
    firstParagraphTextOnly:
      'Soglašam s sodelovanjem v tem intervjuju in z delitvijo mojih odgovorov z raziskovalnim naročnikom za raziskovalne namene.',
    recordingVoice: 'mojega glasu',
    recordingVideo: 'mojega videa',
    recordingVoiceAndVideo: 'mojega glasu in videa',
    forReference: 'Za referenco:',
    interviewTerms: 'Pogoji za razgovor',
    privacyPolicy: 'Politika zasebnosti',
    translatePickLanguage: 'Izberite svoj jezik, nato bomo začeli.',
    letsGo: 'Začnimo',
    consentText: `## Dobrodošli!
To ni tipična anketa.

To je interaktivni AI intervju, zasnovan za poslušanje vaše edinstvene perspektive.
`,
  },
  es: {
    firstParagraph: 'Acepto {interviewTerms} y {privacyPolicy}',
    firstParagraphRecording:
      'Consiento la grabación de {recordingType} en esta entrevista y compartir la grabación con el cliente de investigación con fines de investigación.',
    firstParagraphTextOnly:
      'Consiento participar en esta entrevista y compartir mis respuestas con el cliente de investigación con fines de investigación.',
    recordingVoice: 'mi voz',
    recordingVideo: 'mi video',
    recordingVoiceAndVideo: 'mi voz y video',
    forReference: 'Para referencia:',
    interviewTerms: 'Términos de entrevista',
    privacyPolicy: 'Política de privacidad',
    translatePickLanguage: 'Elige tu idioma y luego comenzaremos.',
    letsGo: 'Comencemos',
    consentText: `## ¡Bienvenido!
Esta no es una encuesta típica.

Esta es una entrevista interactiva con IA, diseñada para escuchar tu perspectiva única.
`,
  },
  sw: {
    firstParagraph: 'Ninakubali {interviewTerms} na {privacyPolicy}',
    firstParagraphRecording:
      'Ninakubali kurekodi {recordingType} katika mahojiano haya na kushiriki rekodi na mteja wa utafiti kwa madhumuni ya utafiti.',
    firstParagraphTextOnly:
      'Ninakubali kushiriki katika mahojiano haya na kushiriki majibu yangu na mteja wa utafiti kwa madhumuni ya utafiti.',
    recordingVoice: 'sauti yangu',
    recordingVideo: 'video yangu',
    recordingVoiceAndVideo: 'sauti na video yangu',
    forReference: 'Kwa rejea:',
    interviewTerms: 'Masharti ya mahojiano',
    privacyPolicy: 'Sera ya faragha',
    translatePickLanguage: 'Chagua lugha yako, kisha tutaanza.',
    letsGo: 'Tuangalie',
    consentText: `## Karibu!
Hii si uchunguzi wa kawaida.

Hii ni usaili wa AI unaoshirikisha, ulioundwa kusikiliza mtazamo wako wa kipekee.
`,
  },
  sv: {
    firstParagraph: 'Jag accepterar {interviewTerms} och {privacyPolicy}',
    firstParagraphRecording:
      'Jag samtycker till inspelning av {recordingType} i denna intervju och till att dela inspelningen med forskningsklienten för forskningsändamål.',
    firstParagraphTextOnly:
      'Jag samtycker till att delta i denna intervju och till att dela mina svar med forskningsklienten för forskningsändamål.',
    recordingVoice: 'min röst',
    recordingVideo: 'min video',
    recordingVoiceAndVideo: 'min röst och video',
    forReference: 'Som referens:',
    interviewTerms: 'Intervjuförhållanden',
    privacyPolicy: 'Sekretesspolicy',
    translatePickLanguage: 'Välj ditt språk, och sedan börjar vi.',
    letsGo: 'Låt oss börja',
    consentText: `## Välkommen!
Detta är inte en typisk undersökning.

Detta är en interaktiv AI-intervju, designad för att höra ditt unika perspektiv.
`,
  },
  tl: {
    firstParagraph: 'Tinanggap ko ang {interviewTerms} at {privacyPolicy}',
    firstParagraphRecording:
      'Pumapayag ako sa pagre-record ng {recordingType} sa panayam na ito at sa pagbabahagi ng recording sa research client para sa mga layunin ng pananaliksik.',
    firstParagraphTextOnly:
      'Pumapayag ako na lumahok sa panayam na ito at ibahagi ang aking mga sagot sa research client para sa mga layunin ng pananaliksik.',
    recordingVoice: 'aking boses',
    recordingVideo: 'aking video',
    recordingVoiceAndVideo: 'aking boses at video',
    forReference: 'Para sa sanggunian:',
    interviewTerms: 'Mga Tuntunin ng Panayam',
    privacyPolicy: 'Patakaran sa Privacy',
    translatePickLanguage: 'Pumili ng wika, at pagkatapos ay magsisimula tayo.',
    letsGo: 'Simulan na natin',
    consentText: `## Maligayang pagdating!
Ito ay hindi karaniwang survey.

Ito ay isang interactive na AI na panayam, idinisenyo upang pakinggan ang iyong natatanging pananaw.
`,
  },
  ta: {
    firstParagraph: 'நான் {interviewTerms} மற்றும் {privacyPolicy} ஐ ஏற்கிறேன்',
    firstParagraphRecording:
      'இந்த நேர்காணலில் {recordingType} பதிவு செய்வதற்கும் ஆராய்ச்சி நோக்கங்களுக்காக ஆராய்ச்சி வாடிக்கையாளருடன் பதிவை பகிர்வதற்கும் சம்மதிக்கிறேன்.',
    firstParagraphTextOnly:
      'இந்த நேர்காணலில் பங்கேற்பதற்கும் ஆராய்ச்சி நோக்கங்களுக்காக ஆராய்ச்சி வாடிக்கையாளருடன் எனது பதில்களை பகிர்வதற்கும் சம்மதிக்கிறேன்.',
    recordingVoice: 'என் குரலின்',
    recordingVideo: 'என் வீடியோவின்',
    recordingVoiceAndVideo: 'என் குரல் மற்றும் வீடியோவின்',
    forReference: 'குறிப்புக்காக:',
    interviewTerms: 'சந்திப்பு விதிமுறைகள்',
    privacyPolicy: 'தனியுரிமை கொள்கை',
    translatePickLanguage: 'உங்கள் மொழியைத் தேர்ந்தெடுக்கவும், பிறகு நாம் தொடங்குவோம்.',
    letsGo: 'தொடங்கவேண்டும்',
    consentText: `## வரவேற்கிறோம்!
இது ஒரு சாதாரண சர்வே அல்ல.

இது உங்கள் தனித்துவமான பார்வையை கேட்க உருவாக்கப்பட்ட ஒரு இன்டர்அக்டிவ் AI நேர்காணல்.
`,
  },
  th: {
    firstParagraph: 'ฉันยอมรับ {interviewTerms} และ {privacyPolicy}',
    firstParagraphRecording:
      'ฉันยินยอมให้บันทึก{recordingType}ในการสัมภาษณ์นี้ และยินยอมให้แชร์การบันทึกกับลูกค้าวิจัยเพื่อวัตถุประสงค์ในการวิจัย',
    firstParagraphTextOnly:
      'ฉันยินยอมเข้าร่วมการสัมภาษณ์นี้ และยินยอมให้แชร์คำตอบของฉันกับลูกค้าวิจัยเพื่อวัตถุประสงค์ในการวิจัย',
    recordingVoice: 'เสียงของฉัน',
    recordingVideo: 'วิดีโอของฉัน',
    recordingVoiceAndVideo: 'เสียงและวิดีโอของฉัน',
    forReference: 'สำหรับอ้างอิง:',
    interviewTerms: 'เงื่อนไขการสัมภาษณ์',
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
    translatePickLanguage: 'เลือกภาษาของคุณ จากนั้นเราจะเริ่มต้น',
    letsGo: 'เริ่มต้นเถอะ',
    consentText: `## ยินดีต้อนรับ!
นี่ไม่ใช่แบบสอบถามทั่วไป

นี่คือการสัมภาษณ์ AI แบบโต้ตอบ ซึ่งออกแบบมาเพื่อรับฟังมุมมองที่เป็นเอกลักษณ์ของคุณ
`,
  },
  tr: {
    firstParagraph: 'Ben {interviewTerms} ve {privacyPolicy} kabul ediyorum',
    firstParagraphRecording:
      'Bu mülakatda {recordingType} kaydedilmesine ve kaydın araştırma müşterisiyle araştırma amaçlı paylaşılmasına onay veriyorum.',
    firstParagraphTextOnly:
      'Bu mülakata katılmaya ve yanıtlarımın araştırma müşterisiyle araştırma amaçlı paylaşılmasına onay veriyorum.',
    recordingVoice: 'sesimin',
    recordingVideo: 'videomin',
    recordingVoiceAndVideo: 'sesimin ve videomin',
    forReference: 'Referans için:',
    interviewTerms: 'Mülakat şartları',
    privacyPolicy: 'Gizlilik Politikası',
    translatePickLanguage: 'Dilinizi seçin ve sonra başlayalım.',
    letsGo: 'Başlayalım',
    consentText: `## Hoş geldiniz!
Bu tipik bir anket değil.

Bu, sizin benzersiz bakış açınızı duymak için tasarlanmış etkileşimli bir AI röportajıdır.
`,
  },
  uk: {
    firstParagraph: 'Я приймаю {interviewTerms} та {privacyPolicy}',
    firstParagraphRecording:
      "Я даю згоду на запис {recordingType} у цьому інтерв'ю та на надання запису дослідницькому клієнту з дослідницькою метою.",
    firstParagraphTextOnly:
      "Я даю згоду на участь у цьому інтерв'ю та на надання моїх відповідей дослідницькому клієнту з дослідницькою метою.",
    recordingVoice: 'мого голосу',
    recordingVideo: 'мого відео',
    recordingVoiceAndVideo: 'мого голосу та відео',
    forReference: 'Для довідки:',
    interviewTerms: 'Умови співбесіди',
    privacyPolicy: 'Політика конфіденційності',
    translatePickLanguage: 'Виберіть свою мову, а тоді ми почнемо.',
    letsGo: 'Давайте почнемо',
    consentText: `## Ласкаво просимо!
Це не типовий опитування.

Це інтерактивне інтерв'ю з ШІ, створене, щоб почути вашу унікальну точку зору.
`,
  },
  ur: {
    firstParagraph: 'میں {interviewTerms} اور {privacyPolicy} کو قبول کرتا ہوں',
    firstParagraphRecording:
      'میں اس انٹرویو میں {recordingType} کی ریکارڈنگ اور تحقیقی مقاصد کے لیے تحقیقی کلائنٹ کے ساتھ ریکارڈنگ شیئر کرنے پر رضامند ہوں۔',
    firstParagraphTextOnly:
      'میں اس انٹرویو میں شرکت کرنے اور تحقیقی مقاصد کے لیے تحقیقی کلائنٹ کے ساتھ اپنے جوابات شیئر کرنے پر رضامند ہوں۔',
    recordingVoice: 'میری آواز',
    recordingVideo: 'میرے ویڈیو',
    recordingVoiceAndVideo: 'میری آواز اور ویڈیو',
    forReference: 'حوالے کے لیے:',
    interviewTerms: 'انٹرویو کی شرائط',
    privacyPolicy: 'رازداری کی پالیسی',
    translatePickLanguage: 'اپنی زبان منتخب کریں، اور پھر ہم شروع کریں گے۔',
    letsGo: 'شروع کرتے ہیں',
    consentText: `## خوش آمدید!
  یہ ایک عام سروے نہیں ہے۔

  یہ ایک انٹرایکٹو AI انٹرویو ہے، جو آپ کے منفرد نقطہ نظر کو سننے کے لیے ڈیزائن کیا گیا ہے۔
  `,
  },
  uz: {
    firstParagraph: 'Men {interviewTerms} va {privacyPolicy}ni qabul qilaman',
    firstParagraphRecording:
      "Ushbu intervyuda {recordingType} yozib olishga va yozuvni tadqiqot mijozi bilan tadqiqot maqsadlarida bo'lishishga roziman.",
    firstParagraphTextOnly:
      "Ushbu intervyuda ishtirok etishga va javoblarimni tadqiqot mijozi bilan tadqiqot maqsadlarida bo'lishishga roziman.",
    recordingVoice: 'ovozimning',
    recordingVideo: 'videomning',
    recordingVoiceAndVideo: 'ovozim va videomning',
    forReference: 'Malumot uchun:',
    interviewTerms: 'Intervyu shartlari',
    privacyPolicy: 'Maxfiylik siyosati',
    translatePickLanguage: "Tilingizni tanlang, so'ngra boshlaymiz.",
    letsGo: 'Boshlaylik',
    consentText: `## Xush kelibsiz!
Bu oddiy so'rovnoma emas.

Bu sizning noyob fikringizni eshitish uchun mo'ljallangan interaktiv AI intervyu.
`,
  },
  vi: {
    firstParagraph: 'Tôi chấp nhận {interviewTerms} và {privacyPolicy}',
    firstParagraphRecording:
      'Tôi đồng ý với việc ghi âm/ghi hình {recordingType} trong cuộc phỏng vấn này và chia sẻ bản ghi với khách hàng nghiên cứu cho mục đích nghiên cứu.',
    firstParagraphTextOnly:
      'Tôi đồng ý tham gia cuộc phỏng vấn này và chia sẻ câu trả lời của tôi với khách hàng nghiên cứu cho mục đích nghiên cứu.',
    recordingVoice: 'giọng nói của tôi',
    recordingVideo: 'video của tôi',
    recordingVoiceAndVideo: 'giọng nói và video của tôi',
    forReference: 'Để tham khảo:',
    interviewTerms: 'Điều kiện phỏng vấn',
    privacyPolicy: 'Chính sách bảo mật',
    translatePickLanguage: 'Chọn ngôn ngữ của bạn, sau đó chúng tôi sẽ bắt đầu.',
    letsGo: 'Bắt đầu thôi',
    consentText: `## Chào mừng!
Đây không phải là một khảo sát thông thường.

Đây là một cuộc phỏng vấn AI tương tác, được thiết kế để lắng nghe quan điểm độc đáo của bạn.
`,
  },
  cy: {
    firstParagraph: 'Derbyniaf {interviewTerms} a {privacyPolicy}',
    firstParagraphRecording:
      "Rwy'n cydsynio i recordio {recordingType} yn y cyfweliad hwn ac i rannu'r recordiad gyda'r cleient ymchwil at ddibenion ymchwil.",
    firstParagraphTextOnly:
      "Rwy'n cydsynio i gymryd rhan yn y cyfweliad hwn ac i rannu fy atebion gyda'r cleient ymchwil at ddibenion ymchwil.",
    recordingVoice: 'fy llais',
    recordingVideo: 'fy fideo',
    recordingVoiceAndVideo: 'fy llais a fideo',
    forReference: 'Er gwybodaeth:',
    interviewTerms: 'Telerau Cyfweliad',
    privacyPolicy: 'Polisi Preifatrwydd',
    translatePickLanguage: 'Dewiswch eich iaith, ac yna byddwn yn dechrau.',
    letsGo: 'Gwnewch yn dechrau',
    consentText: `## Croeso!
Nid arolygon arferol yw hwn.

Mae hwn yn gyfweliad rhyngweithiol â AI, wedi'i gynllunio i wrando ar eich persbectif unigryw.
`,
  },
};
